import moment from 'moment';
import { sortTypes } from '../constants/sortTypes';

const dateCompare = (dateA, dateB, order = 'ascend') => {
  if (!dateA && !dateB) return 0;

  if (order === 'ascend') {
    if (!dateA) return -1;
    if (!dateB) return 1;
  } else {
    if (!dateA) return 1;
    if (!dateB) return -1;
  }

  const momentA = moment(dateA);
  const momentB = moment(dateB);

  const isValidA = momentA.isValid();
  const isValidB = momentB.isValid();

  if (order === 'ascend') {
    if (!isValidA && !isValidB) return 0;
    if (!isValidA) return -1;
    if (!isValidB) return 1;
  } else {
    if (!isValidA && !isValidB) return 0;
    if (!isValidA) return 1;
    if (!isValidB) return -1;
  }

  const diff = momentA.valueOf() - momentB.valueOf();

  return order === 'ascend' ? diff : -diff;
};

const stringCompare = (str, compareStr) =>
  str?.localeCompare(compareStr, undefined, {
    numeric: true,
    sensitivity: 'base',
  });

const numericalDifference = (order, start, end) => {
  const a = start && !isNaN(start) ? start : 0;
  const b = end && !isNaN(end) ? end : 0;

  if (order === 'ascend') {
    return a - b;
  } else {
    return b - a;
  }
};

const stringDifference = (order, start, end) => {
  if (order === 'ascend') {
    return stringCompare(start, end);
  } else {
    return stringCompare(end, start);
  }
};

const dateDifference = (order, start, end) => {
  return dateCompare(start, end, order);
};

export const getValueByPath = (obj, path) => {
  const parts = path.split('.');
  let value = obj;

  for (let i = 0; i < parts.length; i++) {
    value = value[parts[i]];
    if (!value) break;
  }
  return value;
};

export const sortData = (order, keys, a, b) => {
  if (keys?.length >= 1) {
    const { name, type, invertOrder, absValue } = keys[0];
    const effectiveOrder = invertOrder
      ? order === 'ascend'
        ? 'descend'
        : 'ascend'
      : order;

    const aValue = getValueByPath(a, name);

    const bValue = getValueByPath(b, name);

    let start, end;
    switch (type) {
      case sortTypes.string:
        start = String(aValue);
        end = String(bValue);
        break;
      case sortTypes.arrLength:
        start = aValue.length;
        end = bValue.length;
        break;
      case sortTypes.date:
        start = aValue;
        end = bValue;
        break;
      default:
        start = Number(aValue);
        end = Number(bValue);
    }

    if (absValue) {
      start = Math.abs(start);
      end = Math.abs(end);
    }

    if (start !== end) {
      switch (type) {
        case sortTypes.string:
          return stringDifference(effectiveOrder, start, end);
        case sortTypes.date:
          return dateDifference(effectiveOrder, start, end);
        case sortTypes.arrLength:
        case sortTypes.number:
        default:
          return numericalDifference(effectiveOrder, start, end);
      }
    } else {
      return sortData(order, keys.slice(1), a, b);
    }
  } else {
    return 0;
  }
};
